import React, { Component } from 'react';
import {
  shape,
  string,
  arrayOf,
} from 'prop-types';
import { withRouter } from 'react-router';
import _ from 'lodash';
import withApplicationConfig from 'containers/withApplicationConfig';
import { Button, Link } from 'components/common';
import VerticalsList from 'components/Provider/VerticalsList/VerticalsList';

import './ProviderHeader.scss';

export const staticTextKeys = [
  'PROVIDER_HEADER_VIEW_OTHER_BANKS',
  'CREDIT_CARDS',
  'TRAVEL_INSURANCE',
  'MORTGAGES',
  'PERSONAL_LOANS',
  'HOME_INSURANCE',
  'SECURITIES_ACCOUNT',
  'DOMESTIC_HELPER_INSURANCE',
  'PAYROLL_ACCOUNT',
  'CAR_INSURANCE',
];

class ProviderHeader extends Component {
  static propTypes = {
    providerImage: shape({}),
    providerName: string,
    alias: string,
    products: arrayOf(shape({})),
    providers: arrayOf(shape({})),
    staticText: shape({}),
    match: shape({
      params: shape({}),
    }),
    location: shape({}),
    language: string.isRequired,
    // history: shape({}),
    providerProductPageRoute: string,
    resultsPageRouteWithProviderAlias: string,
    resultsPageRouteWithoutProviderAlias: string,
    resultsPageVertical: string,
    mappings: shape({}),
  };

  static defaultProps = {
    providerImage: null,
    providerName: null,
    alias: null,
    products: [],
    providers: [],
    staticText: {},
    match: null,
    location: {},
    // history: null,
    providerProductPageRoute: '',
    resultsPageRouteWithProviderAlias: '',
    resultsPageRouteWithoutProviderAlias: '',
    resultsPageVertical: null,
    mappings: {},
  };

  constructor(props) {
    super(props);
    this.getProviderLink = this.getProviderLink.bind(this);
    this.getVerticals = this.getVerticals.bind(this);
    this.onChangeProvider = this.onChangeProvider.bind(this);
  }

  onChangeProvider({ value }) {
    const {
      match: { params },
      language,
      // history,
      resultsPageVertical,
      providerProductPageRoute,
      resultsPageRouteWithProviderAlias,
    } = this.props;
    const routeTemplate = resultsPageVertical
      ? resultsPageRouteWithProviderAlias
      : providerProductPageRoute;
    if (value) {
      params.alias = value;
      const route = _.template(routeTemplate)({
        language,
        vertical: resultsPageVertical,
        alias: value,
      }).replace('//', '/');

      // TODO: Use server side routing for now
      window.location.href = route;
      // history.push(route);
    }
  }

  getVerticals() {
    const {
      alias,
      products,
      mappings,
      staticText,
      location,
      language,
      resultsPageRouteWithProviderAlias,
      resultsPageRouteWithoutProviderAlias,
    } = this.props;
    return (products || [])
      .filter(({ vertical: productVertical }) => !(mappings[productVertical] || {}).isHidden)
      .map(({ vertical: productVertical }) => {
        const mapping = mappings[productVertical] || {};
        return {
          name: mapping.route,
          value: staticText[productVertical],
          href: _.template(
            mapping.isRouteSkipProviderAlias
              ? resultsPageRouteWithoutProviderAlias
              : resultsPageRouteWithProviderAlias
          )({
            language,
            vertical: mapping.route,
            alias: mapping.isRouteSkipProviderAlias
              ? ''
              : alias,
          }).replace('//', '/'),
          isSelected: location.pathname.toLowerCase().includes(mapping.route),
        };
      });
  }

  getProviderLink() {
    const {
      alias,
      language,
      providerProductPageRoute,
    } = this.props;
    return _.template(providerProductPageRoute)({
      language,
      alias,
    }).replace('//', '/');
  }

  render() {
    const {
      providerImage,
      providerName,
      staticText,
      providers,
      resultsPageVertical,
    } = this.props;
    const verticals = this.getVerticals();
    return (
      <div className="provider-header-container">
        <div className="provider-header-wrapper">
          <div className="provider-header">
            {providerImage && providerImage.url && (
              <Link to={this.getProviderLink()}>
                <img src={providerImage.url} alt={providerName} />
              </Link>
            )}
            <div className="provider-selector-container">
              <Button
                fluid
                as="select"
                tertiary
                // A placeholder value to prevent the dropdown from showing the selected value
                value="foobar"
                placeholder={staticText.PROVIDER_HEADER_VIEW_OTHER_BANKS}
                options={providers.map((
                  { providerName: label, alias: value }
                ) => ({ label, value }))}
                onChange={this.onChangeProvider}
              />
            </div>
          </div>
          {resultsPageVertical && (
            <div className="provider-verticals">
              <VerticalsList verticals={verticals} />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(withApplicationConfig(ProviderHeader, ['routes', 'languages', 'verticals']));
